import React from 'react';

import { Form, Select } from 'antd';

import { WrapperSelect } from 'common/components';

import { useFormatMessage } from 'hooks';

import { INFORMATION_SHEET_OPTIONS } from 'static/Constants';

import Messages from 'i18n/messages/folder';

const { Option } = Select;

const formLayout = { labelCol: { span: 5 }, wrapperCol: { span: 10 } };

const DownloadFolderMemberSetting = () => {
  const messages = useFormatMessage(Messages);

  return (
    <Form.Item
      {...formLayout}
      name='memberDefinedSheets'
      label={messages.memberDefinedSheets}
    >
      <WrapperSelect getPopupContainer={(trigger) => trigger.parentElement}>
        {INFORMATION_SHEET_OPTIONS.map((option, index) => {
          return (
            <Option key={index} value={option}>
              {option?.toUpperCase()}
            </Option>
          );
        })}
      </WrapperSelect>
    </Form.Item>
  );
};

export default DownloadFolderMemberSetting;
